import PointerEventsBoxNone from './types';

const pointerEventsNone: PointerEventsBoxNone = {
    pointerEvents: 'box-none',
};

export default pointerEventsNone;
